export default __webpack_public_path__ + "static/color_selection.7f8950877f773904bad56ae66a049e10.svg";